var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuolu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2H0V3H16V2Z",
    fill: "#6A6A6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11449 3L2 15H14L13.9991 3",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.96681C11 10.642 9.65686 12 8 12C6.34314 12 5 10.642 5 8.96681C5 7.29119 6.15371 6.63319 6.61571 5C8.46157 5.81681 8.46157 8.26681 8.46157 8.26681C8.46157 8.26681 8.92314 6.86681 10.3079 6.51681C10.4231 7.8 11 8.2515 11 8.96681Z",
    fill: "#FF0000",
    stroke: "#FF0000",
    strokeWidth: 1.15789,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuolu);
export default __webpack_public_path__ + "static/media/guolu.02f92ef11c3bb287dd7f0ea41c48ba9f.svg";
export { ForwardRef as ReactComponent };